export default function App() {
  return (
    <div
      className="min-h-screen flex items-center justify-center"
      style={{ backgroundColor: '#660001' }}
    >
      <div className="relative flex items-center justify-center w-full h-screen">

        {/* Outer decorative frame — 3 sided */}
        <div
          className="absolute"
          style={{
            top: '58px',
            bottom: '3%',
            left: '50%',
            transform: 'translateX(-50%)',
            width: 'min(620px, 92vw)',
            borderTop: '1px solid rgba(255,255,255,0.7)',
            borderLeft: '1px solid rgba(255,255,255,0.7)',
            borderRight: '1px solid rgba(255,255,255,0.7)',
          }}
        />

        {/* Inner frame — 3 sided */}
        <div
          className="absolute"
          style={{
            top: 'calc(6% + 6px)',
            bottom: 'calc(3% + 8px)',
            left: '50%',
            transform: 'translateX(-50%)',
            width: 'min(600px, 88vw)',
            borderTop: '1px solid rgba(255,255,255,0.5)',
            borderLeft: '1px solid rgba(255,255,255,0.5)',
            borderRight: '1px solid rgba(255,255,255,0.5)',
          }}
        />

        {/* Main content column */}
        <div
          className="relative flex flex-col items-center"
          style={{ width: 'min(490px, 80vw)', height: '94vh' }}
        >
          {/* Header box */}
          <div
            className="flex flex-col items-center justify-center"
            style={{
              border: '1px solid rgba(255,255,255,0.9)',
              padding: '14px 40px 10px',
              position: 'relative',
              top: '-1px',
              backgroundColor: '#660001',
              zIndex: 10,
            }}
          >
            <h1
              style={{
                fontFamily: "'Montserrat', sans-serif",
                fontWeight: 600,
                fontSize: 'clamp(12px, 3.5vw, 22px)',
                letterSpacing: '0.18em',
                color: 'white',
                margin: 0,
                whiteSpace: 'nowrap',
              }}
            >
              BERMONDSEY ARTS CLUB
            </h1>
            <p
              style={{
                fontFamily: "'Montserrat', sans-serif",
                fontWeight: 300,
                fontSize: 'clamp(6px, 1.2vw, 9px)',
                letterSpacing: '0.2em',
                color: 'rgba(255,255,255,0.8)',
                margin: '4px 0 0',
              }}
            >
              EST 2016
            </p>
          </div>

          {/* Body content */}
          <div className="flex-1 flex flex-col items-center justify-center text-center px-4">
            <p
              style={{
                fontFamily: "'Montserrat', sans-serif",
                fontWeight: 700,
                fontSize: 'clamp(11px, 2.5vw, 17px)',
                letterSpacing: '0.05em',
                color: 'white',
                marginBottom: '28px',
              }}
            >
              We're not going anywhere...
            </p>
            <p
              style={{
                fontFamily: "'Montserrat', sans-serif",
                fontWeight: 400,
                fontSize: 'clamp(10px, 2vw, 15px)',
                letterSpacing: '0.04em',
                color: 'rgba(255,255,255,0.9)',
                lineHeight: '1.9',
                margin: 0,
              }}
            >
              Just taking a moment to give the bar a bit of love.<br />
              New paint, new touches, same spirit.<br />
              We'll be pouring drinks again before you know it.
            </p>
            <p
              style={{
                fontFamily: "'Montserrat', sans-serif",
                fontWeight: 700,
                fontSize: 'clamp(11px, 2.5vw, 17px)',
                letterSpacing: '0.05em',
                color: 'white',
                marginTop: '28px',
              }}
            >
              See you soon.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}